import { Toast } from "@/components/ui/toast.tsx";
import { IS_DEMO } from "@packages/core-client/demo/isDemo.ts";
import { useIsPhone } from "@packages/core-client/hooks/useIsPhone.ts";
import { useFormattingLocale } from "@packages/core-client/i18n/useFormattingLocale.ts";
import { I18nProvider } from "@react-aria/i18n";
import { useCurrentLanguage } from "@squide/i18next";
import { lazy, useEffect } from "react";
import { Outlet } from "react-router";
import { useRuntimeMode } from "@squide/firefly";

const Devtools = lazy(() => import("@packages/devtools/client/Devtools.tsx"));

const DemoControls = lazy(() => import("@packages/devtools/client/demo/DemoControls.tsx"));

const SAVE_BAR_CLEARANCE = { bottom: "6rem" };

export function RootLayout() {
    const mode = useRuntimeMode();
    const locale = useFormattingLocale(useCurrentLanguage());
    const isMobile = useIsPhone();

    useEffect(() => {
        document.documentElement.lang = locale;
    }, [locale]);

    return (
        <I18nProvider locale={locale}>
            <Toast closeButton position={isMobile ? "bottom-center" : "top-right"} offset={isMobile ? SAVE_BAR_CLEARANCE : undefined} mobileOffset={SAVE_BAR_CLEARANCE} />
            <Outlet />
            {mode === "development" && (IS_DEMO ? <DemoControls /> : <Devtools />)}
        </I18nProvider>
    );
}
